<template>
    <div v-if="zohoEnabled">
        <el-dialog :title="title"
                   class="dialog-padding auto"
                   :width="isLargeEnough ? '500px' : '100%'"
                   :visible.sync="hide_add"
                   :before-close="beforeCloseModal"
                   append-to-body>
            <el-form ref="import_zoho_view"
                     class="mt-2 p-0"
                     label-position="top"
                     :rules="rules_zoho_view"
                     :model="zoho_view"
                     @submit.prevent.native="importZohoView">
                <el-form-item prop="view_id"
                              label="Select a Zoho custom view"
                              class="mb-3">
                    <zoho-view-selector v-model="zoho_view.view_id"
                                        ref="zohoViewSelector"
                                        :value="zoho_view.view_id"
                                        @change="zohoViewChanged">
                    </zoho-view-selector>
                </el-form-item>
            </el-form>

            <div class="row pb-3">
                <div class="col-12">
                    <el-button type="success"
                               :disabled="loading_btn || !validated"
                               class="pull-right ml-2"
                               @click="importZohoView">
                        <i class="material-icons loader"
                           v-show="loading_btn">&#xE863;</i>
                        <i class="fa fa-plus"
                           v-show="!loading_btn"></i>
                        <span>Import</span>
                    </el-button>

                    <el-button type="info"
                               class="pull-right"
                               @click="hide_add = false">
                        <span class="fa fa-close"></span>
                        <span>Cancel</span>
                    </el-button>
                </div>
            </div>
        </el-dialog>

        <slot name="trigger">
            <el-button slot="reference"
                       type="text text-sm text-dark-greenish"
                       @click="hide_add = true">
                <i class="el-icon-circle-plus-outline"></i>
                Import Zoho Custom View
            </el-button>
        </slot>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import auth from '../auth'
import {
    acl_mixin,
    form_validation_mixin
} from '../mixins'

export default {
    mixins: [
        acl_mixin,
        form_validation_mixin
    ],

    props: {
        title: {
            required: false,
            type: String,
            default: 'Import Zoho Custom View'
        },
    },

    data() {
        return {
            auth: auth,
            hide_add: false,
            loading_btn: false,
            zoho_view: {
                view_id: null
            },
            rules_zoho_view: {
                view_id: [
                    {
                        required: true,
                        message: 'Please select a Zoho custom view',
                        trigger: 'change'
                    }
                ]
            }
        }
    },

    computed: {
        ...mapState('cache', ['current_company']),

        zohoEnabled() {
            if (this.current_company &&
                this.current_company.zoho_integration_enabled) {
                return true
            }

            return false
        },

        isLargeEnough() {
            let valid_sizes = ['xxl', 'xl', 'lg', 'md']
            if (valid_sizes.includes(this.$mq)) {
                return true
            }
            return false
        }
    },

    methods: {
        importZohoView() {
            this.loading_btn = true
            axios.post(`/api/v1/tag/import-zoho-view/${this.zoho_view.view_id}`).then(() => {
                this.loading_btn = false
                this.hide_add = false
                this.resetZohoView()
                this.$notify({
                    offset: 150,
                    title: 'Tag',
                    message: 'Zoho custom view contacts are now being imported as a tag.',
                    type: 'success',
                    showClose: true,
                })
                this.$emit('success')
            }).catch((err) => {
                this.loading_btn = false
                this.resetZohoView()
                console.log(err)
            })
        },

        resetZohoView() {
            this.zoho_view.view_id = null
            this.resetForm('import_zoho_view')
        },

        beforeCloseModal(done) {
            this.resetZohoView()
            done()
        },

        zohoViewChanged(view_id) {
            this.zoho_view.view_id = view_id
            this.preValidateForm('import_zoho_view')
        },
    },

    watch: {
        hide_add() {
            if (this.hide_add) {
                this.$emit('hide')
            } else {
                this.$emit('show')
                if (this.$refs.zohoViewSelector) {
                    this.$refs.zohoViewSelector.getZohoViews()
                }
            }
        }
    }
}
</script>
